

const SelectOption = (props:any) => {
    return (
        <select 
            multiple={props.multiple ? props.multiple : false} 
            value={(props.selected) ? props.selected : ''}
            onChange={(e) => (props.onOptionChange) && props.onOptionChange(e.target.value)} 
            className={"form-select "} 
            >
            <option>{props.placeholder ? props.placeholder : 'Select Option'}</option>
            {props.data && props.data.map((item: any, key: number) => {
                return <option key={'option_'+Math.random()} value={item[props.value]}>{item[props.lable]}</option>;
            })}
        </select>
    )
}
export default SelectOption;